import Redirect404 from "../components/404/Redirect404";
import { Helmet } from "react-helmet";

export default function PageNotFound404() {
  return (
    <>
      <Helmet>
        <title>FLEXI PAINTERS | Page Not Found</title>
      </Helmet>
      <Redirect404 />
    </>
  );
}
